import { render, staticRenderFns } from "./PortalNotExist.vue?vue&type=template&id=5ef8ff00&"
import script from "./PortalNotExist.vue?vue&type=script&lang=js&"
export * from "./PortalNotExist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports